import { jsx } from 'panel';
import { PropertiesMenuEl } from 'common/widgets/query-block/properties-menu';
import { EventsMenuEl } from 'common/widgets/query-block/events-menu';
export function template() {
  const {
    keydownProxyEl,
    searchFilter
  } = this.state;
  const selectedEvent = this.helpers.getSelectedEvent();
  let menuEl;

  if (selectedEvent) {
    menuEl = jsx(PropertiesMenuEl, {
      attrs: {
        open: this.attr("open"),
        'search-filter': searchFilter,
        'include-custom-properties': this.attr("include-custom-properties"),
        'event-names': [selectedEvent.value],
        selected: this.helpers.getSelectedProperty(),
        'project-id': this.attr("project-id"),
        'workspace-id': this.attr("workspace-id"),
        'track-name': this.attr("track-name"),
        'show-special-date-property': true
      },
      hook: {
        insert: this.helpers.onMenuInserted
      },
      key: 'properties-menu',
      props: {
        context: "breakdown",
        keydownProxyEl,
        //@ts-ignore Refactor iron/common/widgets/query-block/child-menu.ts::ChildMenu to properly inherit this value
        tooltipPositionParentElement: this.tooltipPositionParentElement
      },
      on: {
        select: this.helpers.handleSelectProperty,
        stagedproperty: this.helpers.handleStagedProperty,
        tooltipContextEditDescription: this.helpers.propagateEvent
      }
    });
  } else {
    menuEl = jsx(EventsMenuEl, {
      attrs: {
        open: this.attr("open"),
        'search-filter': searchFilter,
        'data-group-id': this.attr("data-group-id"),
        'project-id': this.attr("project-id"),
        'workspace-id': this.attr("workspace-id")
      },
      hook: {
        insert: this.helpers.onMenuInserted
      },
      props: {
        context: "breakdown",
        keydownProxyEl,
        //@ts-ignore Refactor iron/common/widgets/query-block/child-menu.ts::ChildMenu to properly inherit this value
        tooltipPositionParentElement: this.tooltipPositionParentElement
      },
      key: 'events-menu',
      on: {
        select: this.helpers.handleSelectEvent,
        tooltipContextAction: this.helpers.propagateEvent,
        tooltipContextEditDescription: this.helpers.propagateEvent
      }
    });
  }

  return jsx("div", {
    sel: '.mp-breakdown-menu'
  }, menuEl);
}